import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrdemDiaPage } from './ordem-dia.page';

const routes: Routes = [
  {
    path: '',
    component: OrdemDiaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdemDiaPageRoutingModule {}
